// extracted by mini-css-extract-plugin
export default {"wrapper":"Poster_wrapper__cLKpq"};